import React from "react";
import {
  SFStack,
  SFDialog,
  SFTypography,
  SFUseStyled,
  SFToggleButtons,
  SFBadgeIcons,
} from "@sf-core";
import { useTranslation } from "react-i18next";
import ProficiencyLevels from "./proficiencyLevels";

const { styled } = SFUseStyled();

const StyledLine = styled("div")(({ theme }) => ({
  borderBottom: "1px solid",
  borderColor: theme.palette.grey400.main,
  margin: theme.spacing(0, 4, 3, 4),
  opacity: 0.5,
}));

const StyledSFStack = styled(SFStack)(({ theme }) => ({
  padding: theme.spacing(0, 4, 3, 4),
}));

const DetailsDialog = ({
  open,
  setDialog,
  header,
  badges,
  description,
  proficiencyLevels,
  proficiencyLevel = 1,
  skills,
  skillsTitle,
  titleThumbnail = null,
  actionBtns,
  actionsBoxShadow = false,
  showHierarchy = true,
  customHeader = null,
}) => {
  const { t } = useTranslation();

  return (
    <SFDialog
      size={"lg"}
      contentZeroPadding
      titleBottomLine
      lightBackgroundDialog
      open={open}
      onClose={() => setDialog({ open: false })}
      titleThumbnail={titleThumbnail}
      header={
        <SFStack direction="column" spacing={2.5}>
          {customHeader ? (
            customHeader
          ) : (
            <SFTypography variant="courseCarouselTitle" component="h2">{header}</SFTypography>
          )}
          <SFBadgeIcons
            badges={badges}
            variant={"small"}
            showHierarchy={showHierarchy}
            maxItems={5}
          />
        </SFStack>
      }
      actionBtns={actionBtns && actionBtns}
      actionsBoxShadow={actionsBoxShadow}
    >
      <StyledSFStack spacing={1.5}>
        <SFTypography variant="body2bold">
          {t("profileScreen.detailsDialog.description")}
        </SFTypography>
        <SFTypography variant="body2">{description}</SFTypography>
      </StyledSFStack>
      {proficiencyLevels && (
        <>
          <StyledLine />
          <StyledSFStack spacing={1.5}>
            <SFTypography variant="body2bold">
              {t("profileScreen.detailsDialog.proficiencyLevels")}
            </SFTypography>
            <ProficiencyLevels
              proficiencyLevels={proficiencyLevels}
              defaultActiveStep={proficiencyLevel - 1}
            />
          </StyledSFStack>
        </>
      )}
      {skills && (
        <>
          <StyledLine />
          <StyledSFStack spacing={1.5}>
            <SFTypography variant="body2bold">{skillsTitle}</SFTypography>
            <SFToggleButtons
              size="small"
              disabled={false}
              spacing={1}
              variant={"dark"}
              items={skills?.map((x) => ({
                value: x.id,
                label: x.name,
              }))}
              noHover
              haveCollapsibleItems={true}
              limit={20}
            />
          </StyledSFStack>
        </>
      )}
    </SFDialog>
  );
};

export default DetailsDialog;
